const quantityInput = document.querySelectorAll("[data-item-input='quantity']");
if (quantityInput.length) {
  quantityInput.forEach((input) => {
    initQuantityInput(input, modifyCart);
  });
}

const removeInput = document.querySelectorAll("[data-item-input='remove']");
if (removeInput.length) {
  removeInput.forEach((input) => initRemoveInput(input));
}

function initRemoveInput(input) {
  input.addEventListener('click', function (event) {
    event.preventDefault();
    const value = input.dataset.hasOwnProperty('sub') ? getInputResult('sub', parseInt(input.dataset.quantity)) : 0;
    modifyCart(input, value);
  });
}

const currentLocale = window.Shopify.locale + '-' + window.Shopify.country;
const currentCurrency = window.Shopify.currency.active;
const currencyFormatter = new Intl.NumberFormat(currentLocale, {
  style: 'currency',
  currency: currentCurrency,
  currencyDisplay: 'narrowSymbol',
});

async function modifyCart(input, updated) {
  const itemKey = input.dataset.item;
  const cartItemsLists = document.querySelectorAll('[data-cart_items]');
  const lineItems = document.querySelectorAll("[data-line-item='" + itemKey + "']");
  const cartSubtotals = document.querySelectorAll('[data-cart-subtotal]');
  const cartDiscounts = document.querySelectorAll('[data-cart-discounts]');
  const cartTotals = document.querySelectorAll('[data-cart-total]');
  const cartCounts = document.querySelectorAll('[data-cart-count]');

  //if (lineItems.length) lineItems.forEach((lineItem) => lineItem.classList.add('opacity-50'));
  if (cartItemsLists.length) cartItemsLists.forEach((itemsList) => itemsList.classList.add('opacity-50'));
  if (cartSubtotals.length) cartSubtotals.forEach((subtotal) => subtotal.classList.add('opacity-50'));
  if (cartDiscounts.length) cartDiscounts.forEach((discounts) => discounts.classList.add('opacity-50'));
  if (cartTotals.length) cartTotals.forEach((total) => total.classList.add('opacity-50'));

  const cart = await changeCartItem({
    id: itemKey,
    quantity: updated,
  });
  if (!cart) return;
  const cartItems = await getCartItems();
  if (!cartItems) return;

  const allCurrencyOutputs = [];
  if (cartItemsLists.length)
    cartItemsLists.forEach((itemsList) => {
      const cartUpsellList = itemsList.querySelector('[data-cart_upsell="list"]');
      if (cartUpsellList) {
        //const cartUpsellList = itemsList.removeChild(itemsList.querySelector('[data-cart_upsell="list"]'));
        itemsList.removeChild(cartUpsellList);
      }
      itemsList.innerHTML = '';
      cartItems.cart_drawer.forEach((item) => {
        const clonedItem = item.cloneNode(true);
        itemsList.appendChild(clonedItem);
        const itemQuantityInput = clonedItem.querySelector('[data-item-input="quantity"]');
        const itemRemoveInput = clonedItem.querySelector('[data-item-input="remove"]');
        if (itemQuantityInput) initQuantityInput(itemQuantityInput, modifyCart);
        if (itemRemoveInput) initRemoveInput(itemRemoveInput);
        const currencyOutputs = clonedItem.querySelectorAll('[data-money]');
        if (currencyOutputs && currencyOutputs.length)
          currencyOutputs.forEach((output) => allCurrencyOutputs.push(output));
      });
      if (cartItems.cart_empty) {
        itemsList.appendChild(cartItems.cart_empty.cloneNode(true));
      } else if (cartUpsellList) {
        itemsList.appendChild(cartUpsellList);
      }
    });

  //if (lineItems.length) lineItems.forEach((lineItem) => lineItem.classList.remove('opacity-50'));
  if (cartItemsLists.length) cartItemsLists.forEach((itemsList) => itemsList.classList.remove('opacity-50'));
  if (cartSubtotals.length) cartSubtotals.forEach((subtotal) => subtotal.classList.remove('opacity-50'));
  if (cartDiscounts.length) cartDiscounts.forEach((discounts) => discounts.classList.remove('opacity-50'));
  if (cartTotals.length) cartTotals.forEach((total) => total.classList.remove('opacity-50'));

  if (cartSubtotals.length && cartItems.cart_subtotal) {
    cartSubtotals.forEach((subtotal) => {
      subtotal.textContent = cartItems.cart_subtotal.textContent;
      subtotal.dataset.money = cartItems.cart_subtotal.dataset.money;
      allCurrencyOutputs.push(subtotal);
    });
  }
  if (cartDiscounts.length && cartItems.cart_discounts) {
    cartDiscounts.forEach((discounts) => {
      discounts.innerHTML = cartItems.cart_discounts.innerHTML;
    });
  }
  if (cartTotals.length && cartItems.cart_total) {
    cartTotals.forEach((total) => {
      total.textContent = cartItems.cart_total.textContent;
      total.dataset.money = cartItems.cart_total.dataset.money;
      allCurrencyOutputs.push(total);
    });
  }
  if (allCurrencyOutputs.length) {
    document.body.dispatchEvent(
      new CustomEvent('CurrencyConverterUpdate', {
        detail: { outputs: allCurrencyOutputs },
      }),
    );
  }
  if (cartCounts.length) cartCounts.forEach((count) => (count.textContent = cart.item_count));
  if (!cart.item_count) {
    const cartBubbles = document.querySelectorAll('[data-cart-bubble]');
    if (cartBubbles.length) cartBubbles.forEach((bubble) => bubble.parentElement.removeChild(bubble));
    const checkoutButtons = document.querySelectorAll('[data-cart-checkout]');
    if (checkoutButtons.length)
      checkoutButtons.forEach((button) => {
        button.disabled = true;
        button.classList.remove('lg:hover:underline', 'cursor-pointer');
        button.classList.add('opacity-50', 'pointer-events-none');
      });
  }
}

async function changeCartItem(item) {
  const formData = new FormData();
  for (const key in item) {
    if (item.hasOwnProperty(key)) {
      formData.append(key, item[key]);
    }
  }
  const url = window.Shopify.routes.root + 'cart/change.js';

  const promise = await attemptFetch('changing cart item', url, {
    method: 'post',
    body: formData,
  });

  if (!promise) return false;

  const data = await promise.json();

  return data;
}

async function getCartItems() {
  const url = `${window.Shopify.routes.root}?section_id=cart-drawer`;
  const promise = await attemptFetch('fetching cart drawer items', url);
  if (!promise) return false;
  const html = await promise.text();
  if (!html) return false;
  // fetched section must have regular cart items list and cart drawer items list
  const temp = document.createElement('div');
  temp.innerHTML = html;
  const cartDrawerItemList = temp.querySelector('[data-cart_items]');
  const cartDrawerItems = cartDrawerItemList.querySelectorAll('[data-line-item]');
  const cartEmpty = cartDrawerItemList.querySelector('[data-cart_empty]');
  const cartSubtotal = temp.querySelector('[data-cart-subtotal]');
  const cartDiscounts = temp.querySelector('[data-cart-discounts]');
  const cartTotal = temp.querySelector('[data-cart-total]');
  const data = {
    cart_drawer: cartDrawerItems,
    cart_subtotal: cartSubtotal,
    cart_discounts: cartDiscounts,
    cart_total: cartTotal,
    cart_empty: cartEmpty,
  };
  return data;
}

window.addEventListener('load', (event) => {
  // cart upsell
  const cartUpsellContainer = document.querySelector('[data-cart_upsell="list"]');
  if (cartUpsellContainer) {
    handleCartUpsellItems(cartUpsellContainer);
  }
  // add to cart
  const addToCartForms = document.querySelectorAll('[data-add_to_cart_drawer]');
  if (!addToCartForms.length) return;
  addToCartForms.forEach(handleShoppingButtons);
});

function handleShoppingButtons(form) {
  handleAddToCartDrawer(form);
  handleRedirectAddToCart(form)
}

function handleAddToCartDrawer(form) {
  const cartDrawer = document.querySelector('[data-cart_drawer]');
  if (!cartDrawer) return;

  const requestedUrl = new URL(window.location.href);
  if (requestedUrl.hash && requestedUrl.hash === '#added-to-cart') {
    const cartButton = document.querySelector('[data-cart_button]');
    if (cartButton) cartButton.click();
    requestedUrl.hash = '';
    window.history.replaceState(null, '', requestedUrl.href);
  }

  const returnToUrl = form.querySelector("input[name='return_to']");
  form.addEventListener('submit', function () {
    if (returnToUrl.value != 'back') return;
    const currentUrl = new URL(window.location.href);
    currentUrl.hash = 'added-to-cart';
    returnToUrl.value = currentUrl.href.replace(currentUrl.origin, '');
  });
}

function handleRedirectAddToCart(form) {
  const returnToUrl = form.querySelector("input[name='return_to']");
  const redirectAddToCart = form.querySelector('[data-redirect_add_to_cart]');
  if (!redirectAddToCart) return;

  redirectAddToCart.addEventListener('click', function (event) {
    event.preventDefault();
    returnToUrl.value = redirectAddToCart.dataset.redirect_add_to_cart;
    form.submit();
  });
}

async function handleCartUpsellItems(container) {
  const cartUpsellItems = await getCartUpsellItems(container.dataset.url);
  if (!cartUpsellItems) {
    return;
  }
  const cartUpsellLists = document.querySelectorAll('[data-cart_upsell="list"]');
  cartUpsellLists.forEach((list) => {
    cartUpsellItems.products.forEach((product) => {
      const clonedProduct = product.cloneNode(true);
      list.appendChild(clonedProduct);
      handleAddToCartDrawer(clonedProduct);
    });
  });
}

async function getCartUpsellItems(recommendationsUrl) {
  const promise = await attemptFetch('fetching cart upsell items', recommendationsUrl);
  if (!promise) return false;
  const html = await promise.text();
  if (!html) return false;
  // fetched section must be a list of products
  const temp = document.createElement('div');
  temp.innerHTML = html;
  const cartUpsellProducts = temp.querySelectorAll('[data-cart_upsell="product"]');
  const data = {
    products: cartUpsellProducts,
  };
  return data;
}
